// @flow

import React from 'react';
import PropTypes from "prop-types";
import Tvalue from './Tvalue';
import _ from "underscore";

//import Legacy from '../Legacy';

const propTypes = {
	id: PropTypes.string,
    width: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    options: PropTypes.array,
    value: PropTypes.any,
    /**
     * onChange(onChangeParam, value)
     */
    onChange: PropTypes.func,
	onChangeParam: PropTypes.any
};

const defaultProps = {
	value: null,
	className: "smallinput"
};


class Tselect extends Tvalue {
	
	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.onBlur = this.onBlur.bind(this);
	}
	
	componentWillReceiveProps(newProps) {
		if (this.state.value !== newProps.value) {
			this.setState({
				value: newProps.value
			});
		}
	}

	onChange(e) {
		let newValue = e.target.value;
		if (this.props.onChange) {
			this.setState({
				value: newValue
			},
			function () {
				this.props.onChange(this.props.onChangeParam, newValue);
			}.bind(this));
		} else {
			this.setState({
				value: newValue
			});
		}
	}
	
	onBlur(e) {
		let newValue = e.target.value;
		if (this.props.onChange) {
			this.props.onChange(this.props.onChangeParam, newValue);
		}
	}

	renderOptions(): Array<React$Node> {
		let i = 1;
		let options = [];
		for (let o of this.getOptions()) {
			options.push(<option key={'k' + i++} value={o[0]}>{o[1]}</option>);
		}
		return options;
	}

	getOptions(): Array<[string, string]> {
		if (this.props.options == null) {
			return [["", ""]];
		}
		let options = [];
		for (let o of this.props.options) {
			let value = null;
			let title = null;
			if (_.isArray(o)) {
				value = o[0];
				title = value;
				if (o.length > 1) title = o[1];
			} else {
				value = o;
				title = value;
			}
			if (value == null) value = "";
			if (title == null) title = "";
			options.push([value, title]);
		}
		return options;
	}

	getSelectedValue(): string {
		if (this.state.value != null) return this.state.value;
		let options = this.getOptions();
		return options[0][0];
	}

	
	render(): React$Node {
		let style = {};
		if (this.props.style) style = {...this.props.style};
		if (this.props.width) style.width = this.props.width;
		let classname = 'form-control';
		if (this.props.className) classname += ' ' + this.props.className;
		if (!this.state.isValid) classname += ' invalid';
		return (
			<select id={this.props.id} className={classname} style={style} value={this.getSelectedValue()} onBlur={this.onBlur} onChange={this.onChange}>
				{this.renderOptions()}
			</select>
		);
	}
}

Tselect.propTypes = propTypes;
Tselect.defaultProps = defaultProps;

export default Tselect;
